import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import API from '@/apiRequest';
import Refresh from '@/components/ui-bridge/icons/Refresh';
import classes from '@/containers/ClientFinancialSummary/components/ExportButton/ExportButton.module.scss';
import { showToast } from '@/store/ducks/toasts';

/* MUI FileDownload icon path — matches @material-ui/icons/FileDownload exactly */
const FileDownloadIcon = ({ className }) => (
  <svg
    className={className}
    focusable="false"
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="currentColor"
  >
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </svg>
);

const ExportButton = ({ id, type, search, disabled }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();

  const exportAccount = async exportType => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (search) {
        params.append('search', search);
      }
      const { data } = await API.get(`/account/export/${exportType}`, { params });
      const title = intl.formatMessage({ id: 'summaryTitle' });
      const text = intl.formatMessage({ id: 'consolidatedSummary' });

      dispatch(
        showToast({
          type: 'success',
          title,
          text,
          link: data?.file,
        })
      );
    } catch (err) {
      console.error(
        'Infelizmente um erro aconteceu ao tentar gerar o documento. A mensagem de erro recebida foi: ',
        err
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className={classes.exportButton}
        disabled={loading || disabled}
        onClick={() => exportAccount(type)}
      >
        {loading ? <Refresh className={classes.iconSpin} /> : <FileDownloadIcon className={classes.icon} />}
        {intl.formatMessage({ id: id }) || ''}
      </button>
    </>
  );
};

export default ExportButton;
